const axios = require('axios')

import { getLength, getArea} from 'ol/sphere'
import moment from 'moment'

String.prototype.format = function () {
  var i = 0, args = arguments;
  return this.replace(/{}/g, function () {
    return typeof args[i] != 'undefined' ? args[i++] : '';
  });
};

export function copy (str) {
  return new Promise((resolve, reject) => {
    try {
      const el = document.createElement('textarea')
      el.value = str
      el.style.position = 'absolute'
      el.style.left = '-9999px'
      document.body.appendChild(el)
      el.select()
      const successful = document.execCommand('copy')
      document.body.removeChild(el)
      if (successful) {
        resolve()
      } else {
        reject(Error(successful))
      }
    } catch (err) {
      reject(err)
    }
  })
}

function file (fn, data) {
  const e = document.createEvent('MouseEvent')
  const a = document.createElement('a')
  e.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null)
  a.setAttribute('href', data)
  a.setAttribute('download', fn)
  a.dispatchEvent(e)
  return false
}

// convert radians to degrees
export function radToDeg (rad) {
  return rad * 360 / (Math.PI * 2);
}

// convert degrees to radians
export function degToRad (deg) {
  return deg * Math.PI * 2 / 360;
}

export function scaleFactor (lonlat) {
  return (1 / Math.cos(degToRad(lonlat[1])))
}

// parse url
export function parseURL (href) {
  const match = href.match(/^(?:(https?:)\/\/)?(([^:/?#]*)(?::([0-9]+))?)([/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/)
  return match && {
    href: href,
    protocol: match[1],
    host: match[2],
    hostname: match[3],
    port: match[4],
    pathname: match[5],
    search: match[6],
    hash: match[7],
    query: parseSearch(match[6])
  }
}

export function validURL (href) {
  const match = href.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_+.~#?&//=]*)/g)
  return (match !== null)
}

export function makeLink (text) {
  return String(text).replace(
    /((http|https|ftp|ftps):\/\/[a-zA-Z0-9\-.]+\.[a-zA-Z]{2,3}(\/\S*)?)/g,
    '<a href="$1" target="_blank">$1</a>'
  )
}

export function constructURL (parsedURL) {
  const querystring = serialize(parsedURL.query)
  return parsedURL.protocol + '//' + parsedURL.host + parsedURL.pathname + '?' + querystring;
}

export function serialize (query) {
  return Object.keys(query).map(item => {
    return item + '=' + query[item]
  }).join('&')
}

export function uid () {
  return Math.random().toString(36).substr(2, 10)
}

export function getRandomColor (conf) {
  return randomColor(conf)
}

export function hexToRgbA (hex, a) {
  let c
  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split('')
    if (c.length === 3) {
      c = [c[0], c[0], c[1], c[1], c[2], c[2]]
    }
    c = '0x' + c.join('')
    return 'rgba(' + [(c>>16)&255, (c>>8)&255, c&255].join(',') + ',' + a + ')'
  }
  throw new Error('Bad Hex')
}

export function colorFromArray (arr) {
  if (arr.length === 3) {
    return 'rgb(' + arr.join(',') + ')'
  }
  if (arr.length === 4) {
    return 'rgba(' + arr.join(',') + ')'
  }
  throw new Error('Bad Array')
}

export function formatLength (line, length, decimals = [2, 2]) {
  if (!length) {
    length = getLength(line)
  }
  if (length > 10000) {
    const roundFactor = Math.pow(10, decimals[0])
    return `${(Math.round(length / 1000 * roundFactor) / roundFactor)} km`
  } else {
    const roundFactor = Math.pow(10, decimals[1])
    return `${(Math.round(length * roundFactor) / roundFactor)} m`
  }
}

export function formatArea (polygon, area, decimals = [2, 2]) {
  if (!area) {
    area = getArea(polygon)
  }
  if (area > 1000000) {
    const roundFactor = Math.pow(10, decimals[0])
    return `${(Math.round(area / 1000000 * roundFactor) / roundFactor)} km<sup>2</sup>`
  } else {
    const roundFactor = Math.pow(10, decimals[0])
    return `${(Math.round(area * roundFactor) / roundFactor)} m<sup>2</sup>`
  }
}

export function formatDate (time, short = false) {
  const d = new Date(time)
  let month = (1 + d.getMonth()).toString()
  month = month.length > 1 ? month : '0' + month
  let day = d.getDate().toString()
  day = day.length > 1 ? day : '0' + day
  return short ? day + '.' + month : d.getFullYear() + '.' + month + '.' + day
}

export function formatTime (s) {
  return new Date(s).toTimeString().slice(0, 8)
}

export function deepCopy (json) {
  return JSON.parse(JSON.stringify(json))
}

export function createRandomLayerSignature () {
  // Generates some random (more or less) symbols for layer signature in qgis
  return (Math.random() + 1).toString(36).substring(2)
}

export function fillTemplateRecursively (incomingPlaceholder, layer, xmlComponents) {
  // Make some preparation to clean the brackets, get xml of an incoming placeholder based on its name, and placeholders from there
  const componentsRegex = /{{([\w.]+)}}/gm
  const incomingPlaceholderName = incomingPlaceholder.replaceAll('{{', '').replaceAll('}}', '').replaceAll('.template.xml', '')
  let xmlPlaceholderComponent = xmlComponents[incomingPlaceholderName]
  let newPlaceholders = xmlPlaceholderComponent.match(componentsRegex)
  // Iterate over placeholders of the incoming component and check, if they are components or not
  newPlaceholders.forEach(newPlaceholder => {
    if (newPlaceholder.includes('.template.xml')) {
      // If components, do recursion and get the result back here
      let xmlSubComponent = fillTemplateRecursively(newPlaceholder, layer, xmlComponents)
      xmlPlaceholderComponent = xmlPlaceholderComponent.replaceAll(newPlaceholder, xmlSubComponent)
    } else {
      // Alternatively, fill the placeholder with property defined as layer[newPlaceholderName], e.i. placeholder name should correspond to the property
      let newPlaceholderName = newPlaceholder.replaceAll('{{', '').replaceAll('}}', '')
      xmlPlaceholderComponent = xmlPlaceholderComponent.replaceAll(newPlaceholder, layer[newPlaceholderName])
    }
  })
  return xmlPlaceholderComponent
}

export function fillUniversalQGISTemplate (timeStamps, bbox, xmlComponents, fileName, layers) {
  // Transform layers into simple objects with properties that match placeholders
  let layersToAdd = []
  for (const layer in layers) {
    for (const tId in timeStamps) {
      layersToAdd.push({
        "layer_name": layers[layer].layers[0].title,
        "layer_id": layers[layer].layers[0].params.LAYERS,
        "wms_url": layers[layer].layers[0].url + '?VERSION=1.3.0',
        "date_time": timeStamps[tId],
        "unique_signature": createRandomLayerSignature(),
        "qt_check": layers[layer].checked === true ? 'Qt::Checked' : 'Qt::Unchecked',
        "mce_xmin": bbox[0],
        "mce_ymin": bbox[1],
        "mce_xmax": bbox[2],
        "mce_ymax": bbox[3]
      })
    }
  }
  // Define regex for selecting placeholders, get main template and get placeholders from there
  const componentsRegex = /{{([\w.]+)}}/gm
  let xmlMain = xmlComponents.main
  const mainPlaceholders = xmlComponents.main.match(componentsRegex)
  // Iterating over placeholders (and layers) in main, call recursive algorithm that will get corresponsing xml components and fill them as needed
  // Iteration is needed because almost always there are several layers that should be present within each of the placeholders in main
  mainPlaceholders.forEach(mainPlaceholder => {
    let mainPlaceholderEntries = []
    layersToAdd.forEach(layer => {
      let layerEntry = fillTemplateRecursively(mainPlaceholder, layer, xmlComponents)
      mainPlaceholderEntries.push(layerEntry)
    })
    // Replace a placeholder with content from recursion
    xmlMain = xmlMain.replaceAll(mainPlaceholder, mainPlaceholderEntries.join(' '))
  })

  fileName = fileName + '_' + timeStamps.join(',') + '.qgs'
  downloadFile(fileName, xmlMain)
}


function downloadFile (filename, text) {
  var element = document.createElement('a')
  element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(text))
  element.setAttribute('download', filename)
  element.style.display = 'none'
  document.body.appendChild(element)
  element.click()
  document.body.removeChild(element)
}

export function getRasterDatesFromWms (conf, layer) {
  const wms_layer_name = conf.map.layers.baseLayers[layer].layers[0].params["LAYERS"]

  return new Promise((resolve, reject) => {
    axios.get(conf.api.endpoints.raster_index.getCapabilities)
    .then(function(response) {
      let dates = []

      const parser = new DOMParser()
      const getCapabilitiesXML = parser.parseFromString(response.data, "application/xml")
      const dimensions = getCapabilitiesXML.getElementsByTagName("Dimension")
  
      for (let i = 0; i < dimensions.length; i++) {
        const dimension_name = dimensions[i].parentNode.getElementsByTagName("Name")[0].textContent

        if (dimension_name === wms_layer_name) {
          let _dates = dimensions[i].textContent
          _dates = _dates.split(",")
          _dates.forEach(_date => {
            dates.push(new Date(_date).toISOString())
          });
        }
      }
      resolve(dates)
    }).catch(function (error) {
      console.log(error)
      reject(error)
    })
  })
}

export function getRasterDatesFromApi (conf, layer) {
  let params = {}
  params['raster_types'] = conf.map.layers.baseLayers[layer].layerType
  params['round_to_day'] = conf.api.endpoints.raster_index.params.round_to_day
  params['properties'] = '' + (conf.api.endpoints.raster_index.properties)
  return new Promise((resolve, reject) => { 
    axios.get(conf.api.url + conf.api.endpoints.raster_index.request_path + '?' + serialize(params))
    .then(function (response) {
      let dates = []
      response.data.raster_index.forEach(entry => {
        dates.push(new Date(entry.datetime).toISOString())
      })
      let uniqueDates = [...new Set(dates)]
      resolve(uniqueDates)
    })
    .catch(function (error) {
      console.log(error);
      reject(error)
    })
  })
}

export function groupLinesByType(conf) {
  var groups = conf.chart.legendgroups
  for (const property in groups) {
    groups[property]['lines'] = []
  }
  conf.chart.lines.forEach(line => {
    groups[line.group].lines.push(line)
  })
  return groups
}

export function getPlaygroundImage(request) {
  return new Promise((resolve, reject) => { 
    axios.get(request, {
      responseType: 'arraybuffer'
    })
    .then(function (response) {
      resolve(Buffer.from(response.data, 'binary').toString('base64'))
    })
    .catch(function (error) {
      console.log(error);
      reject(error)
    })
  })
}

export function createFullWMSLink(baseUrl, transparency, layer, time, width, height, epsg, bbox) {
  const result = baseUrl + `?SERVICE=WMS&VERSION=1.3.0&REQUEST=GetMap&FORMAT=image%2Fpng&TRANSPARENT=${transparency}&LAYERS=${layer}&TILED=true&TIME=${time}&WIDTH=${width}&HEIGHT=${height}&CRS=${epsg}&STYLES=&BBOX=${bbox.bbox[0]}%2C${bbox.bbox[1]}%2C${bbox.bbox[2]}%2C${bbox.bbox[3]}`
  return result
}

export function getRangeOfDates (start, end, key, arr = [start.startOf(key)]) {
  if (start.isAfter(end)) {
    throw new Error('start must precede end')
  }
  const next = moment(start).add(1, key).startOf(key)
  if (next.isAfter(end, key)) {
    return arr
  }
  return getRangeOfDates(next, end, key, arr.concat(next))
}